module.exports = __webpack_public_path__ + "img/oberflaechenreinigung.ccc48f4.png";